
export default function WhyChooseUsSection() {
  const features = [
    {
      icon: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Years-of-Experience.svg",
      title: "Years of Experience",
      description: "We're a small local carpet cleaning company in Edmonton, but we're experienced and professional. Years in the industry has made us experts in carpet cleaning and furniture cleaning services."
    },
    {
      icon: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Flexible-Scheduling.svg",
      title: "Flexible Scheduling",
      description: "When you book with us, you can expect steam cleaning service to be provided within 24 hours. Same day appointments are available. Please contact us for details, availability and estimates!"
    },
    {
      icon: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Safe-Cleaning-Products.svg",
      title: "Safe Cleaning Products",
      description: "It's important to use only the best available chemicals in our work. We're very careful when choosing the cleaning products we use. We guarantee the best quality of steam cleaning products."
    },
    {
      icon: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Service-Calls.svg",
      title: "Service Calls",
      description: "If you're not happy, we'll come back to your home or office and re-clean an area until you're satisfied. We're happy when you're happy! Service Calls are FREE of charge!"
    },
    {
      icon: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Family-owned-operated.svg",
      title: "Family owned & operated",
      description: "We're a family owned & operated carpet cleaning company based in Edmonton, Alberta. Our goal is to build long-term relationships with our clients."
    },
    {
      icon: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Digital-Invoicing.svg",
      title: "Digital Invoicing",
      description: "We send Digital Invoices directly to your email. It saves time, paper and it's easier to keep records! Paper invoices are still available upon request!"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why choose us?</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="mb-6">
                <div className="w-16 h-16 mx-auto flex items-center justify-center">
                  <img 
                    src={feature.icon} 
                    alt={feature.title}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
